<template>
  <base-modal size="xl" hide-header hide-footer @close="close" no-padding>
    <div class="col-sm-12 p-3" @click.stop="">
      <div class="col-12">
        <h2>{{ observation.type.name }}</h2>
        <div class="col-sm-12 p-2">
          <Flicking
            v-if="observation.photos.length > 0"
            ref="flicking"
            :options="options"
            :plugins="plugins"
            class="flicking-panel pointer nopads text-center"
            style="height: 60vh"
          >
              <div
                v-for="photo in observation.photos"
                :key="photo.id"
                class="relative nopads stat-map-container slide-img-container"
              >
                  <ImageView
                    ref="image"
                    :img-size="'lg'"
                    :url="getPhotoUrlForObservation(observationPhotoUrl, observation.id, photo)"
                    :contain="true"
                    :show-download-button="true"
                    @click="openImage"
                  />
              </div>
              <template #viewport>
                  <span class="flicking-arrow-prev"></span>
                  <span class="flicking-arrow-next"></span>
              </template>
          </Flicking>
          <div class="col-12 nopads pt-1 pl-4">
            <road-addess-view
              :road-number="observation.road_number"
              :section-number="observation.section_number"
              :distance="observation.distance_from_sec_start"
              :street-name="observation.street_name"
            />
          </div>
          <div v-if="observation.info" class="col-12 nopads pt-1 pl-4">
            <span class="item-detail-text">{{ observation.info }}</span>
          </div>
          <div class="col-sm-12 button-container pb-3">
            <button class="btn btn-secondary form-button" @click.stop="close">{{ $t('common.close') }}</button>
          </div>
        </div>
        <!-- Fullscreen photo -->
        <Transition name="fade">
          <fullscreen-image
            v-if="fullScreenPhotoData"
            :large-images="fullScreenPhotoData"
            :save-disabled="false"
            :photo-ids="fullScreenPhotoIds"
            :panel-index="panelIndex"
            :controls="true"
            @close="closePhoto"
          />
        </Transition>
      </div>
    </div>
  </base-modal>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {observationHelper} from '../mixins/ObservationMixin'
import "@egjs/vue3-flicking/dist/flicking.css";
import Flicking from "@egjs/vue3-flicking";
import { Arrow } from "@egjs/flicking-plugins"
import "@egjs/flicking-plugins/dist/arrow.css";
import ImageView from "@/components/view/ImageView.vue";
import FullscreenImage from "@/components/view/FullscreenImage.vue";
import RoadAddessView from "@/components/velho/RoadAddressView";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'ObservationPhotoViewer',
    components: {BaseModal, RoadAddessView, FullscreenImage, ImageView, Flicking},
    mixins: [restApi, observationHelper],
    props: {
        observation: {
            type: Object,
            default() {
                return null
            }
        }
    },
    data: function () {
        return {
            plugins: [new Arrow()],
            options: {
                preventDefaultOnDrag: true,
                bound: true,
            },
            fullScreenPhotoData: undefined,
            fullScreenPhotoIds: [],
            panelIndex: 0
        }
    },
    methods: {
        getPhotoUrlForObservation: function (baseUrl, observationId, photo) {
            return baseUrl + '/' + observationId + '/' + photo.id
        },
        close: function () {
            this.assignmentMode = false
            this.$emit('close')
        },
        openImage: function () {
            const flicking = this.$refs.flicking
            const imageData = this.$refs.image
            this.fullScreenPhotoData = []
            imageData.forEach((src, index) => {
                this.fullScreenPhotoData.push(src)
                this.fullScreenPhotoIds.push(this.observation.photos[index].id)
            })
            this.panelIndex = flicking.index

        },
        closePhoto() {
            this.fullScreenPhotoData = undefined
        }
    }
}
</script>
<style scoped>
</style>
